export interface MetadataType {
  title?: string;
  description?: string;
  image?: { url: string };
  og_type?: string;
  twitter_site?: string;
  twitter_card?: string;
}

export enum MetaTagOgType {
  website = 'website',
  article = 'article'
}

export enum MetaTagNames {
  title = 'og:title',
  description = 'description',
  ogDescription = 'og:description',
  image = 'og:image',
  type = 'og:type',
  twitterCard = 'twitter:card',
  twitterSite = 'twitter:site'
}
